// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style__wrap___1PlJd"};